import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appUppercaseOnly]',
})
export class UppercaseOnlyDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const filteredValue = input.value
      .replace(/[^a-zA-Z0-9ñÑ]/g, '')
      .toUpperCase();
    this.ngControl.control?.setValue(filteredValue);
  }
}
